import React, { FC } from 'react'

import styled from 'styled-components'

import { BoxShadow, Colors } from 'common-constants/colors'
import { media } from 'components/presentational'

import { useFindDividerText } from '../hooks/useFindDividerText'

export const LandingSeoText: FC = () => {
  const text = useFindDividerText()

  if (text) {
    return (
      <LandingSection>
        <Input type="checkbox" id="less-text" />
        <TextClamp>{text}</TextClamp>
        <More>
          <MoreInner htmlFor="less-text">развернуть</MoreInner>
        </More>
      </LandingSection>
    )
  }

  return null
}

const LandingSection = styled.section`
  display: flex;
  border-radius: 10px;
  box-shadow: ${BoxShadow.BorderLight};
  margin: 20px 0;
  padding: 20px;
  font-size: 15px;
  line-height: 1.3;

  ${media.phone`
    padding: 10px;
    display: -webkit-box;
    -webkit-box-orient: vertical;  
  `}
`

const More = styled.div`
  text-align: right;
  display: none;

  ${media.phone`    
    display: block;
  `}
`

const MoreInner = styled.label`
  cursor: pointer;
  color: ${Colors.link};

  @media (hover: hover) {
    &:hover {
      color: ${Colors.hoverColor};
    }
  }
`

const TextClamp = styled.div`
  ${media.phone`
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;  
    overflow: hidden;
  `}
`

const Input = styled.input`
  display: none;

  &:checked + ${TextClamp} {
    ${media.phone`
      -webkit-line-clamp: unset;
    `}
  }

  &:checked + ${TextClamp} + ${More} {
    ${media.phone`    
      display: none;
    `}
  }
`
